<template>
  <div>
<BaseFrame
   logText="操作日志"
      :logData='records'
      @hanldeLog='hanldeLog'
>
<div slot='affixInfo'>
  <div  class="extraInfo" v-if="infos">
 <div class="infos"  >
          <div>供应商编码:{{$route.params.code}}</div>
          <div>
            <span>
              供应商名称:{{$route.params.name}}
            </span>
            <span>
              社会统一信用代码:{{$route.params.socialCode}}
            </span>
          </div>
        </div>
 <div>
   <span>

    <span>门店名称:</span><span>{{infos.storeName}}</span>
   </span>
   <span>
    <span>首营审批状态:</span><span>{{aduitList[infos.flowStatus-1]}}</span>
   </span>
    <span>
    <span>供应商在店状态:</span>  <span>{{infos.status===1?'启用':'禁用'}}</span>
    </span>
   <span>
    <span>申请单号:</span>  <span>{{infos.billCode}}</span>
    </span>
   <span>
    <span>引用人:</span>  <span>{{infos.createUserName}}</span>
    </span>
   <span>
    <span>引用时间:</span> <span>{{infos.createTime|formatDate}}</span>
    </span>
  </div>
  </div>

</div>
<div slot="content">
  <lk-card title="详细信息" class="cardContainer" v-if="infos">
    <lk-form :label-width='120'>
       <lk-form-item label='是否仅供应援助药品:'>


                  <span>{{infos.isAidOnly===1?'是':'否'  }}</span>
            </lk-form-item>
      <lk-row :gutter='16'>
        <lk-col span='7'>
            <lk-row>
              <lk-form-item label='开户银行:'>
                <span>{{ infos.depositBank | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='银行账号:' prop='bankAccount'>
                <span>{{ infos.bankAccount | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='账期:' prop='accountProid'>
                <span>{{(infos.accountProid || infos.accountProid ===0 ) ? (infos.accountProid  +'天'):'-'}}</span>
              </lk-form-item>
            </lk-row>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col span='7'>
            <lk-row>
              <lk-form-item label='结账条件:' prop='closingCondition'>
                <span>{{ closingConditionList[infos.closingCondition] | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='赊款额上限:' prop='creditLimit'>
                <span>{{(infos.creditLimit || infos.creditLimit === 0) ? (infos.creditLimit +'元') : '-'}}</span>
              </lk-form-item>
            </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='付款方式:' prop='payWay'>
                <span>{{ payWayMap.get(infos.payWay) | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col span='7'>
          <lk-row>
            <lk-form-item label='仓库地址:' prop='repositoryAddress'>
              <span>{{ infos.repositoryAddress | defaultStr }}</span>
            </lk-form-item>
          </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
          <lk-row>
            <lk-form-item label='联系人:' prop='linkMan'>
              <span>{{ infos.linkMan | defaultStr }}</span>
            </lk-form-item>
          </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
          <lk-row>
            <lk-form-item label='电话:' prop='phone'>
              <span>{{ infos.phone | defaultStr }}</span>
            </lk-form-item>
          </lk-row>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col span='7'>
          <lk-row>
            <lk-form-item label='传真:' prop='fax'>
              <span>{{ infos.fax | defaultStr }}</span>
            </lk-form-item>
          </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
          <lk-row>
            <lk-form-item prop='followGoodBillUrl' label='随货同行单:'>
              <Uploader :able='able' v-model.trim="infos.followGoodBillUrl">
              </Uploader>
            </lk-form-item>
          </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
          <lk-row>
          <lk-form-item prop='stampUrl' label='印章印模:'>
            <Uploader :able='able' v-model.trim="infos.stampUrl"></Uploader>
          </lk-form-item>
        </lk-row>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col class="backGroundCard" span='7'>
          <lk-row>
            <lk-form-item prop='qualityEnsureProtocolUrl'>
              <div class="label withPic">
                <label>质量保证协议:</label>
              </div>
              <Uploader :able='able' v-model.trim="infos.qualityEnsureProtocolUrl">
              </Uploader>
            </lk-form-item>
          </lk-row>
          <lk-row>
            <lk-form-item label='质保协议有效期:' prop='qualityEnsureEffecivePeroid'>
              <expire-picker :able='able'  v-model="infos.qualityEnsureEffecivePeroid"/>
            </lk-form-item>
          </lk-row>
        </lk-col>
        <lk-col class="backGroundCard" span='7' offset='1'>
            <lk-row>
              <lk-form-item prop='authorizerBookUrl'>
                <div class="label withPic">
                  <label>授权书:</label>
                </div>
                <Uploader :able='able' v-model.trim="infos.authorizerBookUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='授权书有效期:' prop='authorizerEffecivePeroid'>
                <expire-picker :able='able'  v-model="infos.authorizerEffecivePeroid"/>
              </lk-form-item>
            </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
          <lk-row>
            <lk-form-item label='文件归档编号:' prop='filedDocCode'>
              <span>{{ infos.filedDocCode | defaultStr }}</span>
            </lk-form-item>
          </lk-row>
          <lk-row>
            <lk-form-item label='合格供应商档案表:' prop='qualitiedSupplierTable'>
              <span>{{ infos.qualitiedSupplierTable | defaultStr }}</span>
            </lk-form-item>
          </lk-row>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col span='7'>
          <lk-row>
            <lk-form-item label='受托人姓名:' prop='depositaryName'>
              <span>{{ infos.depositaryName | defaultStr }}</span>
            </lk-form-item>
          </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
          <lk-row>
            <lk-form-item label='受托人身份证号:' prop='depositaryIdCard'>
              <span>{{ infos.depositaryIdCard | defaultStr}}</span>
            </lk-form-item>
          </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
          <lk-row>
            <lk-form-item label='受托人身份证有效期:' prop='depositaryIdEffecivePeroid'>
              <expire-picker :able='able'  v-model="infos.depositaryIdEffecivePeroid"/>
            </lk-form-item>
          </lk-row>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col span='7'>
          <lk-row>
            <lk-form-item label='业务员备案情况:' prop='filedDocState'>
              <span>{{ infos.filedDocState | defaultStr }}</span>
            </lk-form-item>
          </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
          <lk-row>
            <lk-form-item label='备案有效日期:' prop='filedDocEffecivePeroid'>
              <expire-picker :able='able'  v-model="infos.filedDocEffecivePeroid"/>
            </lk-form-item>
          </lk-row>
        </lk-col>
        <lk-col span='7' offset='1'>
          <lk-row>
            <lk-form-item label='采购员意见:' prop='puchasePersonSuggestion'>
              <span>{{ infos.puchasePersonSuggestion | defaultStr }}</span>
            </lk-form-item>
          </lk-row>
        </lk-col>
      </lk-row>
    </lk-form>
  </lk-card>
</div>
</BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import Uploader from '../../../components/Uploader.vue';
import supplier from '../../../services/supplier';
import utils from '../../../libs/utils';
import ExpirePicker from '../../../components/expireInfo/expirePicker.vue';

export default {
  name: 'supplierGeneralFirstInfo',
  components: {
    BaseFrame,
    Uploader,
    ExpirePicker,
  },
  data() {
    return {
      able: false,
      records: [],
      aduitList: ['草稿', '审核中', '审核通过', '审核驳回'],
      closingConditionList: ['', '月结', '现款', '实销实结', '压批', '代销', '预付'],
      infos: null,
    };
  },
  computed: {
    payWayMap() {
      return this.$store.state.publicParams.payWayMap;
    },
  },
  methods: {
    hanldeLog() { // 操作日志预留
      this.getRecord();
    },
    getData() {
      // console.log(this.$route.params);
      supplier.FirstSupplierCheck({ id: this.$route.params.storeId }).then((res) => {
        if (res.data.status === 200) {
          this.infos = res.data.data.storeInfo;
          // this.infos.creditLimit = this.infos.creditLimit ? utils.exchangePercent(this.infos.creditLimit) :'';
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getRecord() {
      supplier.getRecord({ originType: 1, refOriginId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.records = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.extraInfo{
  background: #fff;
  padding-left: 32px;
  padding-bottom: 20px;
   >div>span{
    margin-right: 10px
  }
}
.infos{

div:first-child{
  font-weight: bold
}
  div:last-child {
    // margin-bottom: 16px;
      span{
      margin-right: 18px;

    }
  }
}
</style>
